import * as React from "react";
import { SvgProps } from "../../../utils/interfaces";

const CircleGhostCrossSvg: React.FC<SvgProps> = ({
  width,
  height,
  viewBox = "0 0 18 18",
  color = "#ccc",
  ...rest
}) => {
  return (
    <svg width={width} height={height} viewBox={viewBox} fill="none" {...rest}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9 .667A8.326 8.326 0 00.667 9 8.326 8.326 0 009 17.333 8.326 8.326 0 0017.333 9 8.326 8.326 0 009 .667zm1.575 5.583L9 7.825 7.425 6.25A.83.83 0 106.25 7.425L7.825 9 6.25 10.575a.83.83 0 101.175 1.175L9 10.175l1.575 1.575a.83.83 0 101.175-1.175L10.175 9l1.575-1.575a.83.83 0 000-1.175.845.845 0 00-1.175 0zM2.333 9A6.676 6.676 0 009 15.666 6.676 6.676 0 0015.667 9 6.676 6.676 0 009 2.333 6.676 6.676 0 002.333 9z"
        fill={color}
      />
    </svg>
  );
};

export { CircleGhostCrossSvg };
